import Cloud from './Cloud';

export default Cloud;
